// @ts-nocheck
import * as types from '../types';

const initialState = {
    list: [],
};

const marketDescriptions = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.MARKET_DESCRIPTIONS_LIST_CHANGED: {
            return {
                ...state,
                list: payload,
            };
        }
        default:
            return state;
    }
};

export default marketDescriptions;
